import React from 'react';

import { FiltersWrapper } from '@/modules/CarsStock/components/common.styles';
import EngineTypeFilter from '@/modules/CarsStock/components/Desktop/components/Filters/components/ParamsFilter/components/EngineTypeFilter';
import BodyFilter from '@/modules/CarsStock/components/Desktop/components/Filters/components/ParamsFilter/components/BodyFilter';

import BrandFilter from './components/BrandFilter';
import ModelFilter from './components/ModelFilter';
import ComplectationFilter from './components/ComplectationFilter';
import { ModelsFilterProps } from './types';

function ModelsFilter({ carsType }: ModelsFilterProps) {
  return (
    <FiltersWrapper>
      <BrandFilter />
      <ModelFilter />
      {carsType === 'new' ? (
        <ComplectationFilter />
      ) : carsType === 'commercial' || carsType === 'hybrid' ? (
        <BodyFilter />
      ) : (
        <EngineTypeFilter />
      )}
    </FiltersWrapper>
  );
}

export default ModelsFilter;
